var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Chip, Divider, Drawer, List, ListItemButton, ListItemIcon, ListItemSecondaryAction, ListItemText, useTheme } from '@mui/material';
import { AiBrain01Icon, Audit02Icon, BubbleChatIcon, Building05Icon, CellsIcon, ComputerSettingsIcon, LibraryIcon, LockComputerIcon, MessageQuestionIcon, MoreIcon, UserGroupIcon, UserMultipleIcon } from 'hugeicons-react';
import { Fragment, useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { RoleCategories } from '../../../application/common/constants/role-categories';
import { useAppSelector } from '../../../application/store/useStore';
import useTranslate from '../../../localization/helpers';
import ProtectedElement from '../../components/ProtectedElement';
import AiUserIcon from '../../icons/components/ai-user';
import { Permissions } from '../../permissions';
import logocollapsed from './logo-collapsed.png';
import logo from './logofull.png';
import './style.scss';
var iconSize = 24;
var Sidebar = function (_a) {
    var collapsed = _a.collapsed, onCollapseChange = _a.onCollapseChange, isManuallyOpened = _a.isManuallyOpened;
    var navigate = useNavigate();
    var translate = useTranslate().translate;
    var theme = useTheme();
    var location = useLocation();
    var newDocumentsCount = useAppSelector(function (state) { return state.machineDocument; }).newDocumentsCount;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var isSuperAdmin = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin;
    var menuItems = [
        {
            to: '/chats',
            icon: _jsx(BubbleChatIcon, { size: iconSize }),
            text: translate('common.chats'),
            disabled: false,
            permissions: []
        },
        {
            to: '/assets',
            icon: _jsx(CellsIcon, { size: iconSize }),
            text: translate('common.assets'),
            disabled: false,
            permissions: [Permissions.Machines.Read]
        },
        {
            to: '/knowledge',
            icon: _jsx(LibraryIcon, { size: iconSize }),
            text: translate('common.knowledge'),
            disabled: false,
            permissions: [Permissions.Knowledge.Read]
        },
        {
            to: '/clients',
            icon: _jsx(UserGroupIcon, { size: iconSize }),
            text: translate('common.clients'),
            disabled: false,
            permissions: [Permissions.Clients.Read]
        },
        // {
        //   to: '/work-orders',
        //   icon: <Briefcase06Icon size={iconSize} />,
        //   text: translate('common.workorders'),
        //   disabled: false,
        //   permissions: []
        // },
        {
            to: '/training',
            icon: _jsx(AiBrain01Icon, { size: iconSize }),
            text: translate('common.training'),
            disabled: false,
            permissions: [Permissions.Training.Read]
        },
        {
            to: '/audit',
            icon: _jsx(Audit02Icon, { size: iconSize }),
            text: translate('common.audit'),
            disabled: false,
            permissions: [Permissions.Audit.Read]
        },
        {
            to: '/faqs',
            icon: _jsx(MessageQuestionIcon, { size: iconSize }),
            text: translate('common.faqs'),
            disabled: false,
            permissions: [Permissions.Faqs.Read]
        },
        {
            to: '/settings',
            icon: _jsx(ComputerSettingsIcon, {}),
            text: translate('common.settings'),
            disabled: false,
            permissions: [Permissions.Settings.Read]
        },
        {
            to: '/technicians',
            icon: _jsx(AiUserIcon, {}),
            text: translate('common.technicians'),
            disabled: false,
            permissions: [Permissions.Technicians.Read]
        },
        {
            to: '/companies',
            icon: _jsx(Building05Icon, {}),
            text: translate('common.companies'),
            disabled: false,
            permissions: [Permissions.Companies.Read]
        },
        {
            to: '/users',
            icon: _jsx(UserMultipleIcon, { size: iconSize }),
            text: translate('common.users'),
            disabled: false,
            permissions: [Permissions.Users.Read]
        },
        {
            to: '/roles-permissions',
            icon: _jsx(LockComputerIcon, { size: iconSize }),
            text: translate('common.rolesPermissions'),
            disabled: false,
            permissions: [Permissions.Roles.Read]
        }
    ];
    var mobileMenuItems = [
        {
            to: '/clients',
            icon: _jsx(UserGroupIcon, { size: iconSize }),
            text: translate('common.clients'),
            disabled: false,
            permissions: [Permissions.Clients.Read]
        },
        {
            to: '/assets',
            icon: _jsx(CellsIcon, { size: iconSize }),
            text: translate('common.assets'),
            disabled: false,
            permissions: [Permissions.Machines.Read]
        },
        {
            to: '/chats',
            icon: _jsx(BubbleChatIcon, { size: iconSize }),
            text: translate('common.chats'),
            disabled: false,
            permissions: []
        },
        {
            to: '/knowledge',
            icon: _jsx(LibraryIcon, { size: iconSize }),
            text: translate('common.knowledge'),
            disabled: false,
            permissions: [Permissions.Knowledge.Read]
        },
        // {
        //   to: '/work-orders',
        //   icon: <Briefcase06Icon size={iconSize} />,
        //   text: translate('common.workorders'),
        //   disabled: false,
        //   permissions: []
        // },
        {
            to: '/training',
            icon: _jsx(AiBrain01Icon, { size: iconSize }),
            text: translate('common.training'),
            disabled: false,
            permissions: [Permissions.Training.Read]
        },
        {
            to: '/audit',
            icon: _jsx(Audit02Icon, { size: iconSize }),
            text: translate('common.audit'),
            disabled: false,
            permissions: [Permissions.Audit.Read]
        },
        {
            to: '/faqs',
            icon: _jsx(MessageQuestionIcon, { size: iconSize }),
            text: translate('common.faqs'),
            disabled: false,
            permissions: [Permissions.Faqs.Read]
        },
        {
            to: '/settings',
            icon: _jsx(ComputerSettingsIcon, {}),
            text: translate('common.settings'),
            disabled: false,
            permissions: [Permissions.Settings.Read]
        },
        {
            to: '/technicians',
            icon: _jsx(AiUserIcon, {}),
            text: translate('common.technicians'),
            disabled: false,
            permissions: [Permissions.Technicians.Read]
        },
        {
            to: '/companies',
            icon: _jsx(Building05Icon, {}),
            text: translate('common.companies'),
            disabled: false,
            permissions: [Permissions.Companies.Read]
        },
        {
            to: '/users',
            icon: _jsx(UserMultipleIcon, { size: iconSize }),
            text: translate('common.users'),
            disabled: false,
            permissions: [Permissions.Users.Read]
        },
        {
            to: '/roles-permissions',
            icon: _jsx(LockComputerIcon, { size: iconSize }),
            text: translate('common.rolesPermissions'),
            disabled: false,
            permissions: [Permissions.Roles.Read]
        }
    ];
    var _b = __read(useState(false), 2), drawerOpen = _b[0], setDrawerOpen = _b[1];
    var _c = __read(useState(window.innerWidth < 600), 2), isMobile = _c[0], setIsMobile = _c[1];
    var _d = __read(useState(window.innerWidth >= 600 && window.innerWidth <= 1024), 2), isIpad = _d[0], setIsIpad = _d[1];
    var _e = __read(useState(false), 2), isHovering = _e[0], setIsHovering = _e[1];
    var handleMouseEnter = function () {
        if (!isManuallyOpened && !isMobile && !isIpad) {
            setIsHovering(true);
            onCollapseChange(false);
        }
    };
    var handleMouseLeave = function () {
        if (!isManuallyOpened && !isMobile && !isIpad) {
            setIsHovering(false);
            onCollapseChange(true);
        }
    };
    var handleDrawerOpen = function () {
        setDrawerOpen(true);
    };
    var handleDrawerClose = function () {
        setDrawerOpen(false);
    };
    useEffect(function () {
        var handleResize = function () {
            var isMobileView = window.innerWidth < 600;
            var isIpadView = window.innerWidth >= 600 && window.innerWidth <= 1024;
            setIsMobile(isMobileView);
            setIsIpad(isIpadView);
            if (!isManuallyOpened) {
                if (isMobileView || isIpadView) {
                    onCollapseChange(false);
                }
                else {
                    onCollapseChange(true);
                }
            }
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, [isManuallyOpened, onCollapseChange]);
    useEffect(function () {
        if (location.pathname === '/') {
            navigate('/chats');
        }
    }, [location, navigate]);
    useEffect(function () {
        if (!isHovering && !(isMobile || isIpad) && !isManuallyOpened) {
            onCollapseChange(true);
        }
    }, [isHovering, isMobile, isIpad, isManuallyOpened, onCollapseChange]);
    return (_jsxs("div", { className: "sidebar ".concat(collapsed ? 'collapsed' : '', " ").concat(isHovering ? 'hovered' : '', " disable-scrollbars"), onMouseEnter: !(isMobile || isIpad || isManuallyOpened) ? handleMouseEnter : undefined, onMouseLeave: !(isMobile || isIpad || isManuallyOpened) ? handleMouseLeave : undefined, children: [_jsx("div", { className: 'logo-container', children: _jsx("div", { className: 'logo', onClick: function () { return navigate('/'); }, children: _jsx("img", { src: collapsed ? logocollapsed : logo, height: collapsed ? 40 : 55, alt: 'logo' }) }) }), _jsxs(List, { className: 'menu-items', children: [(isMobile
                        ? mobileMenuItems.slice(0, 4)
                        : isIpad
                            ? mobileMenuItems.slice(0, 6)
                            : menuItems).map(function (item, index) {
                        var isActive = item.to === '/' ? location.pathname === '/' : location.pathname.includes(item.to);
                        var isDividerAfterItem = item.text === translate('common.clients') || item.text === translate('common.faqs');
                        return (_jsx(Fragment, { children: !collapsed ? (_jsxs(List, { sx: {
                                    top: isMobile || isIpad ? undefined : '50px',
                                    paddingBottom: 0,
                                    minWidth: isMobile || isIpad ? '20%' : 'auto',
                                    maxWidth: isMobile || isIpad ? '20%' : 'auto'
                                }, children: [_jsx(ProtectedElement, { permissions: item.permissions, children: _jsxs(ListItemButton, { selected: isActive, component: NavLink, to: item.to, disabled: item.disabled, sx: {
                                                display: 'flex',
                                                my: 0.2,
                                                borderRadius: '8px',
                                                flexDirection: isMobile || isIpad ? 'column' : 'undefined',
                                                '&.Mui-selected': {
                                                    backgroundColor: isMobile || isIpad ? 'transparent' : theme.palette.primary.main[8],
                                                    color: theme.palette.primary.main,
                                                    borderRadius: '8px',
                                                    '&:hover': {
                                                        backgroundColor: isMobile || isIpad ? 'transparent' : theme.palette.primary.main[8],
                                                        color: theme.palette.primary.main
                                                    }
                                                }
                                            }, children: [_jsx(ListItemIcon, { sx: {
                                                        fontWeight: 600,
                                                        margin: isMobile || isIpad ? '0px' : undefined,
                                                        color: isActive ? 'rgba(0, 153, 131, 1)' : 'rgba(69, 79, 91, 1)'
                                                    }, children: item.icon }), _jsx(ListItemText, { primary: item.text, sx: {
                                                        '.MuiTypography-root': {
                                                            fontWeight: 600,
                                                            color: isActive ? 'rgba(0, 153, 131, 1)' : 'rgba(69, 79, 91, 1)',
                                                            fontSize: isMobile || isIpad ? 11 : 16,
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            maxwidth: '100%'
                                                        }
                                                    } }), !isMobile && !isIpad && (_jsx(ListItemSecondaryAction, { children: item.text === translate('common.knowledge') &&
                                                        !isSuperAdmin &&
                                                        newDocumentsCount !== undefined && (_jsx(Chip, { size: 'small', variant: 'soft', color: 'error', label: newDocumentsCount })) }))] }, index) }), isDividerAfterItem &&
                                        (isMobile || isIpad ? (_jsx(Divider, { sx: { display: 'none' } })) : (_jsx(Divider, { sx: { borderColor: 'rgba(145, 158, 171, 0.2)', borderWidth: '1px' } })))] })) : (_jsxs(List, { sx: { top: '50px' }, children: [_jsx(ProtectedElement, { permissions: item.permissions, children: _jsxs(ListItemButton, { selected: isActive, component: NavLink, to: item.to, disabled: item.disabled, sx: {
                                                '&.Mui-selected': {
                                                    backgroundColor: '#00937e14',
                                                    color: '#009983',
                                                    borderRadius: '8px',
                                                    '&:hover': {
                                                        backgroundColor: '#00937e14',
                                                        color: '#009983'
                                                    }
                                                }
                                            }, children: [_jsx(ListItemIcon, { sx: {
                                                        fontWeight: 600,
                                                        color: isActive ? 'rgba(0, 153, 131, 1)' : 'rgba(69, 79, 91, 1)'
                                                    }, children: item.icon }), _jsx(ListItemText, { primary: !collapsed ? item.text : null })] }, index) }), isDividerAfterItem &&
                                        (isMobile || isIpad ? (_jsx(Divider, { sx: { display: 'none' } })) : (_jsx(Divider, { sx: { borderColor: 'rgba(145, 158, 171, 0.2)', borderWidth: '1px' } })))] })) }, index));
                    }), (isMobile || isIpad) && (_jsx(List, { sx: {
                            padding: '8px 8px 0px',
                            minWidth: isMobile || isIpad ? '20%' : 'auto',
                            display: 'flex',
                            height: '100%',
                            alignItems: 'center'
                        }, children: _jsxs(ListItemButton, { sx: { display: 'flex', flexDirection: 'column', padding: 0 }, onClick: handleDrawerOpen, children: [_jsx(ListItemIcon, { sx: {
                                        margin: isMobile || isIpad ? '0px' : undefined
                                    }, children: _jsx(MoreIcon, { size: 24 }) }), _jsx(ListItemText, { sx: {
                                        '.MuiTypography-root': {
                                            fontSize: isMobile || isIpad ? 11 : 16
                                        }
                                    }, primary: translate('common.more') })] }) }))] }), _jsx(Drawer, { anchor: 'right', sx: { zIndex: 1600 }, open: drawerOpen, onClose: handleDrawerClose, children: _jsx(Box, { sx: { width: 250 }, role: 'presentation', onClick: handleDrawerClose, onKeyDown: handleDrawerClose, children: _jsx(List, { children: mobileMenuItems
                            .slice(isIpad ? 6 : isMobile ? 4 : mobileMenuItems.length)
                            .map(function (item, index) {
                            var isActive = item.to === '/' ? location.pathname === '/' : location.pathname.includes(item.to);
                            return (_jsx(ProtectedElement, { permissions: item.permissions, children: _jsxs(ListItemButton, { component: NavLink, to: item.to, onClick: handleDrawerClose, disabled: item.disabled, sx: {
                                        '&.Mui-selected': {
                                            backgroundColor: '#00937e14',
                                            color: '#009983',
                                            '&:hover': {
                                                backgroundColor: '#00937e14',
                                                color: '#009983'
                                            }
                                        }
                                    }, children: [_jsx(ListItemIcon, { sx: {
                                                color: isActive ? 'rgba(0, 153, 131, 1)' : 'rgba(69, 79, 91, 1)'
                                            }, children: item.icon }), _jsx(ListItemText, { primary: item.text, sx: {
                                                color: isActive ? 'rgba(0, 153, 131, 1)' : 'rgba(69, 79, 91, 1)'
                                            } })] }, index) }));
                        }) }) }) })] }));
};
export default Sidebar;
